import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { env } from '@/utils/env.js'

// Default: 30 minutes of inactivity triggers logout
const DEFAULT_IDLE_MS = 30 * 60 * 1000

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click']

export function useIdleLogout(idleMs = DEFAULT_IDLE_MS) {
  const router = useRouter()
  const authStore = useAuthStore()
  const timer = ref(null)

  function resetTimer() {
    clearTimeout(timer.value)
    timer.value = setTimeout(triggerLogout, idleMs)
  }

  async function triggerLogout() {
    if (!authStore.isAuthenticated) return

    env.warn('Session expired due to inactivity — logging out')
    await authStore.logout()
    router.push({ name: 'login', query: { reason: 'idle' } })
  }

  function start() {
    ACTIVITY_EVENTS.forEach(event => window.addEventListener(event, resetTimer, { passive: true }))
    resetTimer()
  }

  function stop() {
    clearTimeout(timer.value)
    ACTIVITY_EVENTS.forEach(event => window.removeEventListener(event, resetTimer))
  }

  onMounted(start)
  onUnmounted(stop)

  return { stop }
}
